<template>
  <div class="error">
    <div v-html="errorMsg" />
  </div>
</template>

<script>
import { exchangeErrorPage } from '@/utils/errorMsg';
import eventBus from '@/utils/eventBus';

export default {
  computed: {
    errorMsg() {
      const errorCode = this.$route.params.errorCode;
      return exchangeErrorPage(errorCode);
    },
  },
  created() {
    eventBus.$emit('scrollUpdate');
  },
  beforeDestroy() {
    eventBus.$emit('scrollTop');
  },
};
</script>

<style></style>
